import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import LeaveRequestForm from "./LeaveRequestForm";
import LeaveRequestList from "./LeaveRequestList";

const LeaveRequest = () => {
  const { hrmsUser, userType } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedEmployee, setSelectedEmployee] = useState(
    location.state?.employee || null
  );

  const [showForm, setShowForm] = useState(
    Boolean(location.state?.employee)
  );

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  React.useEffect(() => {
    if (userType !== 'hrms' && userType !== 'admin') {
      navigate('/hrms/login');
    }
  }, [userType, navigate]);


  if (userType === 'hrms' && !hrmsUser) {
    return <div>Loading...</div>;
  }

  if (userType !== 'hrms' && userType !== 'admin') {
    navigate('/hrms/login');
    return null;
  }

  const handleFormSuccess = () => {
    setShowForm(false);
    setSelectedEmployee(null);
    setRefreshTrigger((p) => p + 1);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-4">
        <h4>Leave Management</h4>

        {userType === 'hrms' && (
          <button
            className="btn btn-primary"
            onClick={() => setShowForm(true)}
          >
            Apply New Leave
          </button>
        )}

      </div>

      {showForm && (
        <LeaveRequestForm
          isAdmin={userType === "admin"}
          selectedEmployee={selectedEmployee}
          onSuccess={handleFormSuccess}
          onCancel={() => {
            setShowForm(false);
            setSelectedEmployee(null);
          }}
        />
      )}

      {userType === "hrms" && (
        <LeaveRequestList refreshTrigger={refreshTrigger} />
      )}

    </div>
  );
};

export default LeaveRequest;
